import { React } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../services";
import { SIGN_IN } from "../../constants/routes";

//Function help to check the authentication before render element
const AuthRoute = ({children, ...rest}) => {
    if (!isAuthenticated()) {
        return <Navigate to={SIGN_IN} replace />
    }
    return children;
};

export default AuthRoute;

